<template>
  <div>
    <div class="top">
      <div class="text">
        <div class="title">
          深入访谈 (IDI)
        </div>
        <div class="value">
          深入访谈 (IDI) 以1对1的方式进行。IDI的参与者有更多的时间发言和回答问题，这有助于对研究主题有更深入的了解。
          </br>

          深度访谈还可以让主持人给予受访者充分的关注，我们的主持人也可以调整访谈风格，以便从访谈中获得最大的收获。

        </div>
        <div><button @click="contact">联系我们</button></div>
      </div>
    </div>

    <div class="recommended">
      <div class="title">
        IDI 建议在以下情况下使用:
      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview1.png">
          <div class="text">
            与小目标人群合作
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview2.png">
          <div class="text">
            地理上分散的研究区域

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview3.png">
          <div class="text">
            需要探索更深层的信息

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview4.png">
          <div class="text">
            要求对市场有快速、易于管理的大致了解

          </div>
        </div>
      </div>
    </div>

    <!-- 卡片 -->
    <div class="cardtitle">
      IDI 项目量
    </div>
    <el-carousel :interval="4000" type="card" :autoplay="false" indicator-position="none">
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2021
          </div>
          <div class="value">
            <div class="hcp">
              1069 医疗人员
            </div>
            <div class="patients">
              209 患者
            </div>
            <div class="consumer">
              1008 消费者
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2022
          </div>
          <div class="value">
            <div class="hcp">
              1071 医疗人员
            </div>
            <div class="patients">
              91 患者
            </div>
            <div class="consumer">
              625 消费者
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2020
          </div>
          <div class="value">
            <div class="hcp">
              981 医疗人员
            </div>
            <div class="patients">
              127 患者
            </div>
            <div class="consumer">
              725 消费者
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="Consultants">
      <div class="title">
        我们定性研究团队的优势

      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview5.png">
          <div class="text">
            当地的专业了解
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview6.png">
          <div class="text">
            行业知识
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview7.png">
          <div class="text">
            训练有素，经验丰富
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview8.png">
          <div class="text">
            笔录-翻译-小结-报告
          </div>
        </div>
      </div>
    </div>

    <cn-case-study />
  </div>
</template>

<script>
import CnCaseStudy from "@/components/cncaseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  components: {
    CnCaseStudy
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "interview",
          source: "",
          information: "Solutions_interview"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "interview",
          source: this.$route.query.source,
          information: "Solutions_interview"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/cn/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 90px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interviewbg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.recommended,
.Consultants {
  padding: 120px;
  text-align: center;
  .title {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 60px;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // padding: 50px;
    .box {
      width: 20.5%;
      img {
        width: 100px;
        margin-bottom: 30px;
      }
      .text {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
  }
}
.cardtitle {
  color: #2cb1e9;
  padding: 80px 120px 30px 120px;
  text-align: center;
  font-weight: 700;
  font-size: 45px;
}
@media screen and (max-width: 576px) {
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 20px;
      }
    }
  }
  .recommended,
  .Consultants {
    .title {
      font-size: 80px;
      margin-bottom: 100px;
    }
    .value {
      .box {
        width: 90%;
        img {
          width: 400px;
        }
        .text {
          font-size: 70px;
          margin-bottom: 150px;
        }
      }
    }
  }
  .cardtitle {
    font-size: 80px;
  }
}
</style>
<style lang="scss">
.el-carousel__container {
  margin-bottom: 60px;
  height: 350px;
}
.el-carousel__item {
  .medium {
    padding: 50px;
    text-align: center;
    font-size: 35px;
    font-weight: 700;
    color: #fff;
    .year {
      font-size: 40px;
      margin-bottom: 60px;
    }
  }
  .el-carousel__mask {
    opacity: 0.4;
  }
}

.el-carousel__item:nth-child(2n) {
  background-color: #2cb1e9;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #2cb1e9;
}

@media screen and (max-width: 576px) {
  .el-carousel__item {
    width: 60%;
    .medium {
      font-size: 65px;
      .year {
        font-size: 80px;
      }
    }
  }
  .el-carousel {
    // height: 600px;
    .el-carousel__container {
      height: 600px !important;
      .el-carousel__arrow {
        width: 100px;
        height: 100px;
        i {
          font-size: 40px;
        }
      }
    }
  }
}
</style>